export default __webpack_public_path__ + "static/media/bootstrap.5d590f6c.svg";